import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateStructure } from "@tools";
import { TimelineVirtualCell, TimelineBillingCell } from "../../TimelineCells";
import { Grid } from "@material-ui/core";
import useStyle from "./TimelineBillingContents.style";

export const TimelineBillingContents = observer(() => {
  const classes = useStyle();
  const structure = useEstimateStructure();

  return (
    <Grid item container className={classes.root}>
      {structure.currentTimeline?.billingMonths.map((month) => (
        <TimelineVirtualCell
          key={getDateKey(month.startDate)}
          month={month}
        >
          <TimelineBillingCell
            month={month}
          />
        </TimelineVirtualCell>
      ))}
    </Grid>
  );
});